import { useMemo } from 'react';

const useEnvironment = () => {
  //dev인지 prod인지 확인
  //NEXT_PUBLIC_TOSS_REDIRECT_BASE_URL가 prod/dev에 따라 나눠져있기 때문에 이걸로 환경을 구분하도록 함
  const isDevOrLocal =
    process.env.NEXT_PUBLIC_URL == "http://localhost:3100" ||
    process.env.NEXT_PUBLIC_URL == "https://home.dev.potoo.ai";

  const isLocal = process.env.NEXT_PUBLIC_UR === "http://localhost:3100";
  const isStage = process.env.NEXT_PUBLIC_UR === "https://home.stage.potoo.ai";
  const isDev = process.env.NEXT_PUBLIC_UR == "https://home.dev.potoo.ai";
  const isNonProd = isLocal || isDev || isStage;

  // dev, local / prod 환경에 따라 다른 값들
  const CREDIT_PER_SKU = process.env.NEXT_PUBLIC_CREDIT_SINGLE_SKU || 4;

  return { isDevOrLocal, isNonProd, CREDIT_PER_SKU };
};

export { useEnvironment };
